import React from 'react';

class RequiredFieldDisclaimer extends React.Component {
	render() {
		return <p><strong className="text-danger">*</strong> Indicates Required Information</p>;
	}
}

export default RequiredFieldDisclaimer;
